import React from "react";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";
const LoanDrawTransactionDetailsModal = ({ clickedRowData }) => {
  return <LmsTable
    actionButtons={["export"]}
    apiSuffix={`draws/loan-draw-transaction-details/${clickedRowData?.id}`}
    onClickModalSize="fullscreen"
    columnClickOptions={{
      drawOrCharge: {
        idProp: "id",
        path: (rowData) => rowData?.drawOrCharge === "Charge" ? "accounting-loan-transactions" : "servicing-draws/edit",
        isIframeModal: true
      }
    }}
  />;
};

const MainTable = () => {
  const actionsButtons = ["export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="draws/loan-draw-transactions"
    onClickModalContent={(_, { clickedRowData }) => <LoanDrawTransactionDetailsModal clickedRowData={clickedRowData} />}
    onClickModalSize="fullscreen"
    columnLabelsDictionary={{
      loanNumber: "Loan #"
    }}
    columnClickOptions={{
      loanNumber: {
        idProp: "id",
        isModalContentLink: true,
      }
    }}
    rowsBackgroundCustomColor={(row) => row.colorId}
  />;
};

const LmsAccountingLoanDrawsAndTransactions = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<MainTable />);
};

export default LmsAccountingLoanDrawsAndTransactions;